module.exports = anno;


//////////////////
// WEBPACK FOOTER
// external "anno"
// module id = 2492
// module chunks = 0